export type PricingTemplateId = 'default' | 'airport' | 'dollarCoffeeDay';

export const DEFAULT_PRICING: { [name: string]: number } = {
	Americano: 2.75,
	Espresso: 2.75,
	Cortado: 3.75,
	Latte: 3.85,
	Mocha: 3.95,
	Cappuccino: 3.85,
	'French Vanilla': 3.85,
	'Hot Chocolate': 2.75,
	'Dirty Chai': 3.95,
	'Chai Latte': 3.75,
	'Oat Cortado': 3.75,
	'Oat Latte': 3.85,
	'Oat Mocha': 3.95,
	'Oat Cappuccino': 3.85,
	'Oat Dirty Chai': 3.95,
	'Oat Chai Latte': 3.75,
	'Oat Hot Chocolate': 2.75,
	'Coconut Cortado': 3.75,
	'Coconut Latte': 3.85,
	'Coconut Mocha': 3.95,
	'Coconut Cappuccino': 3.85,
	'Coconut Dirty Chai': 3.95,
	'Coconut Chai Latte': 3.75,
	'Coconut Hot Chocolate': 2.75,
	'Matcha Latte': 4.25,
	'Coconut Matcha Latte': 4.25
};

export const AIRPORT_PRICING: { [name: string]: number } = {
	Americano: 3.50,
	Espresso: 3.50,
	Cortado: 4.25,
	Latte: 4.25,
	Mocha: 4.50,
	Cappuccino: 4.25,
	'French Vanilla': 4.25,
	'Hot Chocolate': 3.50,
	'Dirty Chai': 4.50,
	'Chai Latte': 3.50,
	'Oat Cortado': 4.50,
	'Oat Latte': 4.75,
	'Oat Mocha': 4.90,
	'Oat Cappuccino': 4.75,
	'Oat Dirty Chai': 4.75,
	'Oat Chai Latte': 4.25,
	'Oat Hot Chocolate': 4.25,
	'Coconut Cortado': 4.50,
	'Coconut Latte': 4.75,
	'Coconut Mocha': 4.90,
	'Coconut Cappuccino': 4.75,
	'Coconut Dirty Chai': 4.75,
	'Coconut Chai Latte': 4.25,
	'Coconut Hot Chocolate': 4.25,
	'Matcha Latte': 4.90,
	'Coconut Matcha Latte': 4.90
};

export const DOLLAR_COFFEE_DAY_PRICE = 1;

export const DOLLAR_COFFEE_DAY_PRICING: { [name: string]: number } = Object.keys(DEFAULT_PRICING).reduce(
	(prices, name) => {
		prices[name] = DOLLAR_COFFEE_DAY_PRICE;
		return prices;
	},
	{} as { [name: string]: number }
);

export const PRICING_TEMPLATES: { [id in PricingTemplateId]: { [name: string]: number } } = {
	default: DEFAULT_PRICING,
	airport: AIRPORT_PRICING,
	dollarCoffeeDay: DOLLAR_COFFEE_DAY_PRICING
};

export const PRICING_TEMPLATE_LABELS: { [id in PricingTemplateId]: string } = {
	default: 'Default',
	airport: 'Airport',
	dollarCoffeeDay: '$1 Coffee Day'
};
